import request from '@/utils/request'

// 查询公告列表
export function listNotice(query) {
  return request({
    url: '/system/notice/list',
    method: 'get',
    params: query
  })
}

// 查询公告详细
export function getNotice(noticeId) {
  return request({
    url: '/system/notice/' + noticeId,
    method: 'get'
  })
}

// 新增公告
export function addNotice(data) {
  return request({
    url: '/system/notice',
    method: 'post',
    data: data
  })
}

// 修改公告
export function updateNotice(data) {
  return request({
    url: '/system/notice',
    method: 'put',
    data: data
  })
}

// 删除公告
export function delNotice(noticeId) {
  return request({
    url: '/system/notice/' + noticeId,
    method: 'delete'
  })
}
//查询消息公告列表
export function  getMessagesPage(query) {
  return request({
    url: '/system/messages/list',
    method: 'get',
    params: query
  })
}
//获取未读消息公告总数
export function  getMessagesRecord(id) {
  return request({
    url: '/system/messages/unread/count',
    method: 'get',
  })
}
// 消息已阅
export function messagesPushRecord(id) {
  return request({
    url: `/system/messagesPushRecord/read/${id}`,
    method: 'put',
  })
}
